// Strategy challenges (DESIGN.md §5 v2): short scripted races with a fixed
// weather plan and medal times. Gold is 1 % under the autopilot's best strategy
// through the real pit lane (scripts/challenge-medals.ts); silver +4 %, bronze +9 %.

import type { RaceConfig } from './race';

export interface Challenge {
  id: string;
  name: string;
  description: string;
  config: RaceConfig;
  /** Total race time targets, seconds. */
  medals: { gold: number; silver: number; bronze: number };
}

const medals = (gold: number): Challenge['medals'] => ({ gold, silver: Math.round(gold * 1.04), bronze: Math.round(gold * 1.09) });

export const CHALLENGES: Challenge[] = [
  {
    id: 'two-compound',
    name: 'Sprint strategy',
    description: '8 laps, dry. Start on Softs; you must also run a second dry compound.',
    config: { laps: 8, weather: 'dry', seed: 11, startCompound: 'soft', mandatoryCompounds: true, plan: { startWetness: 0, cells: [] } },
    medals: medals(924),
  },
  {
    id: 'beat-the-rain',
    name: 'Beat the rain',
    description: '8 laps on Mediums. A heavy shower arrives around half distance. When do you box?',
    config: { laps: 8, weather: 'shower', seed: 12, startCompound: 'medium', mandatoryCompounds: true, plan: { startWetness: 0, cells: [{ from: 4.2, to: 6.4, peak: 0.7 }] } },
    medals: medals(1063),
  },
  {
    id: 'drying-track',
    name: 'Drying track',
    description: '6 laps from a wet start on Inters. Call the switch to slicks at the right moment.',
    config: { laps: 6, weather: 'wet-start', seed: 13, startCompound: 'inter', mandatoryCompounds: true, plan: { startWetness: 0.5, cells: [] } },
    medals: medals(753),
  },
  {
    id: 'storm',
    name: 'Tropical storm',
    description: '6 laps. A Sepang downpour hits early. Inters or full wets?',
    config: { laps: 6, weather: 'storm', seed: 14, startCompound: 'medium', mandatoryCompounds: true, plan: { startWetness: 0, cells: [{ from: 1.6, to: 4.4, peak: 1 }] } },
    medals: medals(871),
  },
];

export function medalFor(c: Challenge, total: number): 'gold' | 'silver' | 'bronze' | undefined {
  if (total <= c.medals.gold) return 'gold';
  if (total <= c.medals.silver) return 'silver';
  if (total <= c.medals.bronze) return 'bronze';
  return undefined;
}
